import { Actions, actionsFor, actionTypesFor, TableActionTypes } from "../table/table.actions"

export const types: TableActionTypes = actionTypesFor("USERS_TABLE")
export const actions: Actions = actionsFor("USERS_TABLE")
